import React from "react";
import icon from "images/heart.svg";
import ImageButton from "components/Buttons/ImageButton";

const Like = () => {
  const handleOnClicked = () => {};
  return <ImageButton src={icon} onClick={handleOnClicked} size="24px" />;
};
export default Like;
